import styled from "styled-components";

import { setFontVariant, colorsPalettes, $robotoFontFamily } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const EmailsContainer = styled(Flex)`
    justify-content: flex-start;
    width: 100%;
    flex: 1 0 100%;
    flex-wrap: wrap;
    margin-top: 16px;
    max-height: 250px;
    padding-right: 20px;
    overflow-y: auto;
`;

export const EmailsList = styled.div`
    padding: 0;
    margin: 20px 0;
`;

const EmailListItem = styled.li`
    margin-bottom: 0px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    font-weight: bold;
    line-height: 20px;

    & span {
        font-size: inherit;
        max-width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
    }
`;

export const EmailItem = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    font-family: ${$robotoFontFamily};
    font-weight: bold;
    line-height: 20px;
`;

const BaseText = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    line-height: 20px;
    flex: 1 0 100%;
`;

export const EmailsListPrefix = styled(BaseText)``;

export const EmailsListSuffix = styled(BaseText)``;

const ContentText = styled(Flex)`
    justify-content: flex-start;
    flex: 1 0 100%;
`;

const TooltipWrapper = styled.div`
    max-width: 350px;
    overflow-wrap: break-word;
`;

export const HandsImage = styled.img`
    height: 105px;
    margin: 24px auto 0 auto;
`;
